exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#dropdown-header-help .dropdown-menu.dropdown-menu-right.show {\n\tmin-width: 240px;\n}\n.app.no-scroll {\n\toverflow: hidden !important;\n\theight: 100vh !important;\n}\n", ""]);

// exports
